import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/PageHeader";
import CrudPage from "@/components/CrudPage";
import GenericTable from "@/components/GenericTable";
import { useApi } from "@/lib/api";
import { COLLECTION_LABELS } from "@/lib/sp";
import * as C from "@/pages/spConfigs";

const FIXED = [
  { key: "consultations", label: "Consultations", config: C.consultationsConfig },
  { key: "prescriptions", label: "Ordonnances", config: C.prescriptionsConfig },
  { key: "vaccinations", label: "Vaccinations", config: C.vaccinationsConfig },
  { key: "growth_metrics", label: "Croissance", config: C.growthConfig },
  { key: "lab_results", label: "Analyses", config: C.labsConfig },
  { key: "imaging_exams", label: "Imagerie", config: C.imagingConfig },
  { key: "med_documents", label: "Documents", config: C.documentsConfig },
  { key: "access_grants", label: "Partages d'accès", config: C.grantsConfig },
  { key: "symptom_submissions", label: "Signalements", config: C.symptomsConfig },
  { key: "epi_cases", label: "Cas épidémiques", config: C.epiCasesConfig },
];
const HIDDEN = new Set(FIXED.map((f) => f.key));

export default function RecordsPage() {
  const api = useApi();
  const [extra, setExtra] = useState([]);
  useEffect(() => { api("get", "/sp-collections").then((cols) => setExtra(cols.filter((c) => !HIDDEN.has(c)))); }, [api]);
  const tabs = [...FIXED, ...extra.map((c) => ({ key: c, label: COLLECTION_LABELS[c] || c.replace(/_/g, " ") }))];
  return (
    <div className="space-y-8" data-testid="records-page">
      <PageHeader title="Dossiers médicaux" subtitle="Consultations, ordonnances, vaccins, croissance, analyses, imagerie, documents, partages et cas épidémiques. Ajouts, modifications et suppressions sont envoyés à l'application. Les nouveaux modules de l'app apparaissent ici automatiquement." />
      <Tabs defaultValue="consultations">
        <TabsList className="bg-white border border-stone-200 flex-wrap h-auto">
          {tabs.map((t) => <TabsTrigger key={t.key} value={t.key} data-testid={`tab-${t.key}`}>{t.label}</TabsTrigger>)}
        </TabsList>
        {tabs.map((t) => (
          <TabsContent key={t.key} value={t.key} className="mt-6">
            {t.config ? <CrudPage key={t.key} config={t.config} /> : <GenericTable collection={t.key} />}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
